import { defineComponent as _defineComponent } from 'vue'
import AppComponent from '~/core/layouts/AppComponent.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'empty',
  setup(__props) {


return { __sfc: true,AppComponent }
}

})